<fui-inline-fascia [disabled]="disabled" [tabindex]="tabindex">
    <fui-fixtures>
        <fui-fixture>
            <fui-switch-dom [disabled]="disabled" [focussed]="focussed" [hovered]="hovered" [valued]="valued"
                            [ngClass]="'clickable'">
                <input (blur)="onBlur($event)" [disabled]="disabled" (focus)="onFocus($event)" #input
                       [(ngModel)]="value" type="checkbox">
            </fui-switch-dom>
        </fui-fixture>
    </fui-fixtures>
</fui-inline-fascia>
